export * from './operationPermissionGroup.service';
import { OperationPermissionGroupService } from './operationPermissionGroup.service';
export * from './role.service';
import { RoleService } from './role.service';
export const APIS = [OperationPermissionGroupService, RoleService];
